import { useBrand } from '@contexts/index'

const FinancialTerms = () => {
  const brand = useBrand()

  const privacyLink =
    brand === 'lexus'
      ? 'https://www.lexus.co.uk/customer-data/privacy-policy'
      : 'https://www.toyota.co.uk/footer/privacy-policy'

  const unsubscribeLink =
    brand === 'lexus'
      ? 'https://forms.lexus.co.uk/webforms/unsubscribe.aspx'
      : 'https://forms.toyota.co.uk/unsubscribe'

  return (
    <div className="my-8" data-gt-componentname="terms">
      <p>We will endeavour to respond to your email within 2 working days.</p>
      <br />
      <p>
        Please note that we are only able to discuss details of an agreement
        with the agreement holder. If you wish to discuss a partner/family
        member&apos;s agreement with us, we will need the customer&apos;s
        expressed authority to do this. We will require the customer to contact
        us on{' '}
        <a
          className="underline whitespace-nowrap"
          href={brand === 'lexus' ? 'tel:+443708507788' : 'tel:+443708505533'}
          data-gt-name="ctaevent"
          data-gt-action="terms-click-tel"
          data-gt-label={brand === 'lexus' ? '0370 850 7788' : '0370 850 5533'}
        >
          {brand === 'lexus' ? '0370 850 7788' : '0370 850 5533'}
        </a>{' '}
        and provide details of the third party&apos;s name, date of birth and a
        password, which will be used to identify them.
      </p>
      <br />

      <div>
        <p>
          If you’re finding it stressful or difficult to make your current
          payments, or have concerns about making them in future, please let us
          know as we’re here to help. We have a range of options available to
          support your individual circumstances. At{' '}
          {brand === 'lexus' ? 'Lexus' : 'Toyota'} Financial Services, we are
          committed to supporting you and helping you find the best solution.
        </p>
        <br />
        <p className="pb-2">To get in touch, contact us by:</p>
        <ul>
          <li className="pl-4  pb-2">
            • Typing ’Speak to an Agent’ in the live messenger located at the
            bottom right of this screen to be directed to one of the team
          </li>

          <li className="pl-4 pb-2">
            • Phone{' '}
            <a
              className="underline whitespace-nowrap"
              href={
                brand === 'lexus' ? 'tel:+443702430805' : 'tel:+443702430804'
              }
              data-gt-name="ctaevent"
              data-gt-action="terms-click-tel"
              data-gt-label={brand === 'lexus' ? '03702430805' : '03702430804'}
            >
              {brand === 'lexus' ? '0370 243 0805' : '0370 243 0804'}
            </a>{' '}
            (our opening hours are Monday to Friday 9am-5.30pm)
          </li>
          <li className="pl-4 pb-2 ">
            • Email{' '}
            <a
              className="underline"
              href={`mailto:Customeroutcomes@uk.toyota-fs.com ${
                brand === 'lexus'
                  ? 'Customeroutcomes@uk.lexus-fs.com'
                  : 'Customeroutcomes@uk.toyota-fs.com'
              }`}
              target={'_blank'}
              rel={'noopener noreferrer'}
              data-gt-name="ctaevent"
              data-gt-action="email-click-link"
              data-gt-label={
                brand === 'lexus'
                  ? 'Customeroutcomes@uk.lexus-fs.com'
                  : 'Customeroutcomes@uk.toyota-fs.com'
              }
            >
              {brand === 'lexus'
                ? 'Customeroutcomes@uk.lexus-fs.com'
                : 'Customeroutcomes@uk.toyota-fs.com'}
            </a>
            .
          </li>
        </ul>
        <p>
          Remember, the earlier you get in touch the sooner we can help. It’s
          worth noting, missed or late payments may negatively impact your
          credit score and this could make it more difficult for you to obtain
          credit in the future
        </p>
        <br />
        <p> Helpful Links</p>
        <p>
          If you’re in need of free and impartial help and debt advice, there
          are several not for profit organisations who can support, such as{' '}
          <a
            className="underline whitespace-nowrap"
            href={'https://www.citizensadvice.org.uk'}
            target={'_blank'}
            rel={'noopener noreferrer'}
            data-gt-name="ctaevent"
            data-gt-action="help-click-link"
            data-gt-label={'www.citizensadvice.org.uk'}
          >
            www.citizensadvice.org.uk
          </a>
          ,{' '}
          <a
            className="underline whitespace-nowrap"
            href={'https://www.nationaldebtline.org'}
            target={'_blank'}
            rel={'noopener noreferrer'}
            data-gt-name="ctaevent"
            data-gt-action="help-click-link"
            data-gt-label={' www.nationaldebtline.org'}
          >
            www.nationaldebtline.org
          </a>
          ,{' '}
          <a
            className="underline whitespace-nowrap"
            href={'https://www.moneyhelper.org.uk'}
            target={'_blank'}
            rel={'noopener noreferrer'}
            data-gt-name="ctaevent"
            data-gt-action="help-click-link"
            data-gt-label={'www.moneyhelper.org.uk'}
          >
            www.moneyhelper.org.uk
          </a>{' '}
          and{' '}
          <a
            className="underline whitespace-nowrap"
            href={'https://www.stepchange.org'}
            target={'_blank'}
            rel={'noopener noreferrer'}
            data-gt-name="ctaevent"
            data-gt-action="help-click-link"
            data-gt-label={'www.stepchange.org'}
          >
            www.stepchange.org
          </a>
          .
        </p>{' '}
        <br />
      </div>

      <p>
        {brand === 'lexus'
          ? 'Lexus Financial Services '
          : 'Toyota Financial Services (UK) PLC '}
        will use and process your personal data to assist you with and manage
        the matter that you have contacted us about.
      </p>
      <br />
      <p>
        Information about our use and handling of personal information, your
        data protection rights and how to contact us is provided in our{' '}
        <a
          className="underline whitespace-nowrap"
          href={privacyLink}
          target={'_blank'}
          rel={'noopener noreferrer'}
          data-gt-name="ctaevent"
          data-gt-action="terms-click-link"
          data-gt-label={privacyLink}
        >
          privacy notice
        </a>
        .
      </p>
      <br />
      <p>
        You can withdraw or change any of your communications preferences at any
        time. To do this please contact our{' '}
        <a
          className="underline"
          href="tel:+443708505533"
          data-gt-name="ctaevent"
          data-gt-action="terms-click-link"
          data-gt-label="03708505533"
        >
          Customer Experience Team
        </a>{' '}
        or complete our{' '}
        <a
          className="underline"
          href={unsubscribeLink}
          target={'_blank'}
          rel={'noopener noreferrer'}
          data-gt-name="ctaevent"
          data-gt-action="terms-click-link"
          data-gt-label={unsubscribeLink}
        >
          form
        </a>
        .
      </p>
    </div>
  )
}

export default FinancialTerms
